/**
 * Gets the current Shepherd.js tour.
 *
 * @return {Shepherd.Tour|undefined} The current tour if available, otherwise null.
 */
const getCurrentWalkthrough = () => {
	// Check if _uo.utility.walkthrough and activeTour are available
	const tour = _uo?.utility?.walkthrough?.activeTour;

	if ( ! tour ) {
		return;
	}

	// Return the current tour
	return tour;
}

export default getCurrentWalkthrough;
